import styled from "styled-components";
import { AllieDataGrid } from '../../../components/DataGrid';

export const StyledDatagrid = styled(AllieDataGrid)`
  > ion-card-content {
    border-radius: var(--allie-radius-xxl);

    > table > thead > tr > th {
      background-color: var(--allie-datagrid-header);
    }
  }

  > ion-card-header > tfoot {
    display: none;
  }
`;

export const DatagridWrapper = styled.div`
  position: relative;
  width: 100%;

  > table {
    margin-bottom: 0 !important;
  }
`;

export const DatagridDownloadButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  padding-top: 0;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  color: var(--allie-color-neutral-50);

  &:hover {
    background: var(--allie-color-neutral-10);
    color: var(--allie-color-neutral-90);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
